module.exports = __webpack_public_path__ + "img/Showtime-text.0f432271.jpg";